import { combineReducers } from 'redux';
import employees from './employees';
import approvedBuyers from './approved-buyers';

export default combineReducers({
  employees,
  approvedBuyers,
  // ... reducers for other company-settings sections/tabs
});
